export const CONVERSATION_LIVE_CHAT = 'CONVERSATION_LIVE_CHAT';
export const CONVERSATION_EMAIL = 'CONVERSATION_EMAIL';
export const CAPACITY_LIMITS_URL = 'conversations-assignments/v1/capacity-limits';
export const CAPACITY_LOAD_URL = 'conversations-assignments/v1/capacity-load';